module.exports = __webpack_public_path__ + "static/media/PasswordChange.d775ff4f.svg";